import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2599e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal d-flex align-items-center justify-content-center"
}
const _hoisted_2 = {
  class: "modal-content",
  style: {"width":"25%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Supplier Info", -1))
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name:", -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address:", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mobile" }, "Mobile:", -1))
const _hoisted_10 = { class: "form-group d-flex justify-content-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-save" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-close" }, null, -1))
const _hoisted_13 = { class: "card mb-5 mb-xl-10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#activity_report",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Asset Register")
  ])
], -1))
const _hoisted_15 = {
  id: "activity_report",
  class: "collapse show"
}
const _hoisted_16 = { class: "collapse show" }
const _hoisted_17 = { class: "card-body border-top p-6" }
const _hoisted_18 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Organization Type", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1))
const _hoisted_28 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1))
const _hoisted_30 = { class: "col-md-2 mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_32 = {
  key: 1,
  disabled: "",
  type: "button",
  class: "btn btn-success mt-6 p-3",
  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex pt-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
      ])
    ])
  ])
], -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  id: "kt_info_update",
  class: "card shadow-none container-fluid px-0"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header bg-success text-light",
  id: "kt_info_update_header"
}, null, -1))
const _hoisted_38 = {
  class: "card-body position-relative",
  id: "kt_info_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_info_update_body",
  "data-kt-scroll-dependencies": "#kt_info_update_header, #kt_info_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_39 = { class: "position-relative" }
const _hoisted_40 = { class: "scroll-y row" }
const _hoisted_41 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "New Row"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"150px"}
    }, "Supplier"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"150px"}
    }, "Name of Asset "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"150px","margin-top":"10px"}
    }, "Entry Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Voucher Number"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Value of Acquisition"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Usefull Life"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"120px"}
    }, "Identification No"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Package No"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"120px"}
    }, "Location"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Opening Balance (Depreciation) "),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Opening WDV (Depreciation)"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Rate in % (Depreciation)"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Charged For The Period (Depreciation)"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "Balance End (Depreciation)"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"120px"} }, "WDV wdv_end"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "required",
      style: {"min-width":"120px"}
    }, "Date and Remarks")
  ])
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus text-light" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "mt-3" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = ["onUpdate:modelValue"]
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["onUpdate:modelValue", "onInput"]
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = {
  class: "card-footer py-5 text-left",
  id: "kt_info_update_footer"
}
const _hoisted_65 = { class: "svg-icon svg-icon-3 ms-2 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isModalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.formData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "address",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.address) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.formData.address]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "mobile",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.formData.mobile]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "submit",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveSupplier && _ctx.saveSupplier(...args))),
                  class: "btn btn-success btn-sm"
                }, [
                  _hoisted_11,
                  _createTextVNode(" Save")
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn btn-danger btn-sm ms-3"
                }, [
                  _hoisted_12,
                  _createTextVNode(" Close")
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Form, {
      onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _hoisted_22,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        placeholder: "Select Tranche",
                        modelValue: _ctx.tranche_id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tranche_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            value: "",
                            label: "Select Tranche"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Select Tranche")
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: trans.id,
                              label: trans.label,
                              value: trans.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(trans.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Type",
                        modelValue: _ctx.type,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.type) = $event)),
                        style: {"width":"100%"},
                        onChange: _ctx.btnCheckStatus
                      }, {
                        default: _withCtx(() => [
                          (_ctx.is_seip_user == true)
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 0,
                                value: "SEIP"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("SEIP")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.is_seip_user == true || _ctx.is_entity_user == true)
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: "Training Partner"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Training Partner")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.is_seip_user == true || _ctx.is_institute_user == true)
                            ? (_openBlock(), _createBlock(_component_el_option, {
                                key: 2,
                                value: "Training Institute"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Training Institute")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    (_ctx.btnCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Partner",
                            modelValue: _ctx.batch.entity_id,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _ctx.getTrainingInstitute
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: data.id,
                                  label: '[' + data.entity_short_name + '] - ' + data.entity_name
                                            ,
                                  value: data.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString('[' + data.entity_short_name + '] - ' + data.entity_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "entity_id",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.instituteCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Institute",
                            modelValue: _ctx.batch.institute_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                            name: "institute_id",
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info.id,
                                  label: info.institute_name,
                                  value: info.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.institute_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      (_ctx.type)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.courseActivityReport())),
                            type: "button",
                            class: "btn btn-success mt-6 p-3",
                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                          }, [
                            _createTextVNode(" Next "),
                            _hoisted_31
                          ]))
                        : (_openBlock(), _createElementBlock("button", _hoisted_32, [
                            _createTextVNode(" Next "),
                            _hoisted_33
                          ]))
                    ])
                  ]),
                  _hoisted_34,
                  (_ctx.AssetSection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_el_form, {
                                model: _ctx.formData,
                                rules: _ctx.rules,
                                ref: "formRef"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("table", _hoisted_41, [
                                      _hoisted_42,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.address_details, (data, index) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                            _createElementVNode("td", null, [
                                              (index < 1)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addProfession && _ctx.addProfession(...args))),
                                                    class: "btn btn-icon btn btn-dark btn-sm me-1"
                                                  }, _hoisted_44))
                                                : _createCommentVNode("", true),
                                              (index >= 1)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.removeProfession && _ctx.removeProfession(...args))),
                                                    class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                                  }, _hoisted_46))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_el_select, {
                                                class: "form-select-solid",
                                                placeholder: "Select Supplier",
                                                modelValue: data.supplier,
                                                "onUpdate:modelValue": ($event: any) => ((data.supplier) = $event),
                                                filterable: "",
                                                style: {"width":"100%"}
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (data) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: data.id,
                                                      label: data.name,
                                                      value: data.id
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(data.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
                                                class: "btn btn-icon btn btn-dark btn-sm me-1"
                                              }, _hoisted_48)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.name) = $event),
                                                type: "text",
                                                class: "required form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_49), [
                                                [_vModelText, data.name]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_50, [
                                                _createVNode(_component_el_form_item, { prop: "start_date" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_date_picker, {
                                                      modelValue: data.entry_date,
                                                      "onUpdate:modelValue": ($event: any) => ((data.entry_date) = $event),
                                                      "value-format": "YYYY-MM-DD",
                                                      format: "DD-MM-YYYY",
                                                      style: {"width":"100%","margin-top":"13px"},
                                                      type: "date",
                                                      name: "start_date"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.file_no) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_51), [
                                                [_vModelText, data.file_no]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.value_acquisition) = $event),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_52), [
                                                [_vModelText, data.value_acquisition]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.usefull_of_life) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_53), [
                                                [_vModelText, data.usefull_of_life]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.identification) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_54), [
                                                [_vModelText, data.identification]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.package) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_55), [
                                                [_vModelText, data.package]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.location) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_56), [
                                                [_vModelText, data.location]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.opening_balance) = $event),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_57), [
                                                [_vModelText, data.opening_balance]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.opening_wdv) = $event),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_58), [
                                                [_vModelText, data.opening_wdv]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.rate_in) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_59), [
                                                [_vModelText, data.rate_in]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.charged_period) = $event),
                                                onInput: ($event: any) => (_ctx.calculateWDV(data)),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 40, _hoisted_60), [
                                                [_vModelText, data.charged_period]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                disabled: "",
                                                "onUpdate:modelValue": ($event: any) => ((data.balance) = $event),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_61), [
                                                [_vModelText, data.balance]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                disabled: "",
                                                "onUpdate:modelValue": ($event: any) => ((data.wdv_end) = $event),
                                                type: "number",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_62), [
                                                [_vModelText, data.wdv_end]
                                              ])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((data.remarks) = $event),
                                                type: "text",
                                                class: "form-control form-control-sm",
                                                rows: "3"
                                              }, null, 8, _hoisted_63), [
                                                [_vModelText, data.remarks]
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]),
                                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("button", {
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formSubmit())),
                                      type: "button",
                                      class: "btn btn-success mr-3 p-3",
                                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                                    }, [
                                      _createTextVNode(" Save "),
                                      _createElementVNode("span", _hoisted_65, [
                                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                      ])
                                    ])
                                  ])), [
                                    [_directive_loading, _ctx.load]
                                  ])
                                ]),
                                _: 1
                              }, 8, ["model", "rules"])
                            ])
                          ])), [
                            [_directive_loading, _ctx.load]
                          ])
                        ])), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ], 64))
}